import { PropsWithChildren, ReactNode, useMemo, useState } from "react";
import {
  DialogFactory,
  DialogManagerContext,
} from "../../contexts/dialogManager";

export const DialogManager = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogComponent, setDialogComponent] = useState<ReactNode>(null);
  const context = useMemo(
    () => ({
      openDialog: (factory: DialogFactory) => {
        setIsOpen(true);
        setDialogComponent(
          factory({
            open: true,
            onClose: () => {
              setIsOpen(false);
              setDialogComponent(null);
            },
          })
        );
      },
    }),
    []
  );

  return (
    <DialogManagerContext.Provider value={context}>
      {children}
      {isOpen ? dialogComponent : null}
    </DialogManagerContext.Provider>
  );
};
